<template>
    <el-dialog v-dialogDrag class="dialog" width="1080px" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑供应商信息
            </div>
        </div>
        <div class="dialog_body">
            <el-tabs style="padding: 0 20px" v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-date"></i> 供应商信息 </span>
                    <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                             label-width="120px">
                        <el-form-item label="供应商名称" prop="supplierName">
                            <el-input style="width:200px" v-model="form.supplierName" placeholder="请输入供应商名称"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商地址">
                            <el-input style="width:200px" v-model="form.supplierAddress" placeholder="请输入供应商地址"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商类别">
                            <el-select v-model="form.supplierType" placeholder="请选择供应商类别" style="width: 200px">
                                <el-option label="单位" value="单位"></el-option>
                                <el-option label="个人" value="个人"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="供应商等级">
                            <el-select v-model="form.supplierLevel" placeholder="请选择供应商等级" style="width: 200px">
                                <el-option label="一级供应商" value="一级供应商"></el-option>
                                <el-option label="二级供应商" value="二级供应商"></el-option>
                                <el-option label="三级供应商" value="三级供应商"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系人">
                            <el-input style="width:200px" v-model="form.contactName" placeholder="请输入联系人"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="form.contactSex" placeholder="请选择性别" style="width: 200px">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="联系人电话">
                            <el-input style="width:200px" v-model="form.contactTel" placeholder="请输入联系人电话"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人部门">
                            <el-input style="width:200px" v-model="form.contactDept" placeholder="请输入联系人部门"></el-input>
                        </el-form-item>
                        <el-form-item label="是否合格">
                            <el-select v-model="form.isQualified" placeholder="请选择是否合格" style="width: 200px">
                                <el-option label="合格" value="合格"></el-option>
                                <el-option label="不合格" value="不合格"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="等级评价">
                            <el-select v-model="form.appraiseLevel" placeholder="请选择等级评价" style="width: 200px">
                                <el-option label="优" value="优"></el-option>
                                <el-option label="良" value="良"></el-option>
                                <el-option label="中" value="中"></el-option>
                                <el-option label="差" value="差"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="经营范围">
                            <el-input style="width:200px" v-model="form.business" placeholder="请输入经营范围"></el-input>
                        </el-form-item>
                        <el-form-item label="纳税人识别号">
                            <el-input style="width:200px" v-model="form.dutyNo" placeholder="请输入纳税人识别号"></el-input>
                        </el-form-item>
                        <el-form-item label="公司法人">
                            <el-input style="width:200px" v-model="form.corporation" placeholder="请输入公司法人"></el-input>
                        </el-form-item>
                        <el-form-item label="公司电话">
                            <el-input style="width:200px" v-model="form.tel" placeholder="请输入公司电话"></el-input>
                        </el-form-item>
                        <el-form-item label="公司传真">
                            <el-input style="width:200px" v-model="form.fax" placeholder="请输入公司传真"></el-input>
                        </el-form-item>

                        <el-form-item label="邮箱">
                            <el-input style="width:200px" v-model="form.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="网址">
                            <el-input style="width:200px" v-model="form.url" placeholder="请输入网址"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行">
                            <el-input style="width:200px" v-model="form.bankName" placeholder="请输入开户银行"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账号">
                            <el-input style="width:200px" v-model="form.bankNo" placeholder="请输入银行账号"></el-input>
                        </el-form-item>
                        <el-form-item label="注册资金(万元)">
                            <el-input style="width:200px" v-model="form.registeredCapital" placeholder="请输入注册资金"></el-input>
                        </el-form-item>
                        <el-form-item label="质量体系认证">
                            <el-input v-model="form.certifyQuality"  rows="2" type="textarea"
                                      placeholder="请输入质量体系认证" style="width: 660px">
                            </el-input>
                            <el-button type="primary" size="medium" icon="el-icon-upload" @click="uploadFile('certifyQuality')">上传
                            </el-button>
                            <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile('certifyQuality')">查看
                            </el-button>
                        </el-form-item>
                        <el-form-item label="证书编号" style="width: 100%">
                            <el-input v-model="form.certifyNo"  rows="2" type="textarea"
                                      placeholder="请输入证书编号" style="width: 660px">
                            </el-input>
                            <el-button type="primary" size="medium" icon="el-icon-upload" @click="uploadFile('certifyNo')">上传
                            </el-button>
                            <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile('certifyNo')">查看
                            </el-button>
                        </el-form-item>

                        <el-form-item label="备注" class="bzClass">
                            <el-input style="width: 860px" rows="2" type="textarea"
                                      placeholder="请输入备注" v-model="form.remark" >
                            </el-input>
                        </el-form-item>

                    </el-form>

                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  附件上传
                    </span>
                    <fileupload :fileUrl="fileUrl" :fileParam="fileParam"
                                :fileListUrl="fileListUrl" :delFileUrl="delFileUrl" :fileKey="fileKey"></fileupload>
                </el-tab-pane>
            </el-tabs>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>

        <fileuploadMx v-if="showFileUpload"
                    :fileUrl="fileUrl"
                    :fileParam="fileParamMx"
                    :fileListUrl="fileListUrl"
                    :delFileUrl="delFileUrl"
                    :fileKey="fileKey"
                    @closeDialog="closeDialog">
        </fileuploadMx>
        <fileDialog v-if="showFileDialog"
                    :fileParam="fileParamMx"
                    :loading="dialogLoading"
                    :fileListUrl="fileListUrl"
                    @closeDialog="closeDialog">
        </fileDialog>
    </el-dialog>
</template>

<script>
    import fileuploadMx from '@/components/tools/fileupload/dialog'
    import fileDialog from '@/components/tools/fileupload/showDialog'
    import fileupload from '@/components/tools/fileupload'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {
            fileupload,
            fileDialog,
            fileuploadMx
        },
        data() {
            return {
                activeName: "first",
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
                fileUrl: "/supplierfile/uploadFiles",
                fileListUrl: "/supplierfile/getSupplierFile",
                delFileUrl: "/supplierfile/delete",
                fileKey: "supplierFileId",
                fileParam: {
                    supplierId: this.formData.supplierId
                },
                fileParamMx: {
                    supplierId: this.formData.supplierId
                },
                showFileUpload: false,
                showFileDialog: false,
            };
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async submitForm() {
                if(this.$pub.isEmpty(this.form.supplierName)){
                    this.$message({message: '请输入供应商名称', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
            closeDialog() {
                this.showFileUpload = false;
                this.showFileDialog = false;
            },
            uploadFile(kind) {
                this.fileParamMx={
                    supplierId: this.formData.supplierId,
                    kind:kind
                };
                this.showFileUpload = true;
            },
            showFile(kind) {
                this.fileParamMx={
                    supplierId: this.formData.supplierId,
                    kind:kind
                };
                this.showFileDialog = true;
            },
        }
    }
</script>

